import { render, staticRenderFns } from "./jtjjzh.vue?vue&type=template&id=df902948&scoped=true"
import script from "./jtjjzh.vue?vue&type=script&lang=js"
export * from "./jtjjzh.vue?vue&type=script&lang=js"
import style0 from "./jtjjzh.vue?vue&type=style&index=0&id=df902948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df902948",
  null
  
)

export default component.exports